import React from "react";

export default function Section12() {
  const services = [
    {
      title: "World-Class Shopify Development Company for Growing Brands in UAE",
      description: `At Mean3, we specialize in providing top-tier Shopify development services in UAE that blend high-performance development with visually striking design. Whether you're looking to build a custom Shopify store or optimize your existing platform, our team is dedicated to delivering digital storefronts that are fast, responsive, scalable, and tailored to your brand identity.`,
      extra: `As official Shopify experts in Dubai, we don’t just build stores. We create buying experiences that drive growth, enhance conversions, and foster customer loyalty. Whether you’re launching a new store, replatforming from another system, or scaling an existing Shopify Plus site, our expert team ensures every detail supports your long-term success.`
    },
    {
      title: "Trusted by Innovative Brands in UAE",
      description: `Our work has powered the growth of forward-thinking brands across industries. Clients trust Mean3 for our deep platform expertise, creative solutions, and commitment to delivering measurable results. From Shopify store development in Dubai to enterprise-level Shopify ecommerce development, we help businesses across the UAE succeed in the competitive ecommerce landscape.`,
    },
  ];



  return (
    <div className="w-full Section11">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        <h1 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Shopify Website Development Services in UAE
        </h1>
        {/* <p className="leading-[22px] text-[#373737] pb-[1%] text-sm md:text-base mb-[20px]">
          At Mean3, we specialize in creating custom Shopify solutions that blend high-performance development with visually striking design. Our team is dedicated to helping ecommerce brands of all sizes thrive on Shopify, delivering digital storefronts that are fast, responsive, scalable, and tailored to your unique brand identity.
        </p> */}

        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#f5f5f5] text-[#373737]"} p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px]`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h3>
              <p className="mb-3 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>
              {service.extra && (
                <p className="text-xs md:text-sm leading-[22px] font-open">
                  {service.extra}
                </p>
              )}
            </div>
          ))}

        </div>
      </div>
    </div>
  );
}
